import cashierBonusTypes from "./cashierBonusTypes";
import cashierBonusApi from "./cashierBonusApi";

const cashierBonusActions = {
    getCashierBonusAnalytics: (branchId, dates, resolve, reject) => async dispatch => {
        dispatch({ type: cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_PENDING })
        await cashierBonusApi.getCashierBonusAnalytics(branchId, dates)
            .then((data) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_ERROR })
                reject && reject(e)
            })
    },
    getGroupCashierBonusAnalytics: (groupId, dates, resolve, reject) => async dispatch => {
        dispatch({ type: cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_PENDING })
        await cashierBonusApi.getGroupCashierBonusAnalytics(groupId, dates)
            .then((data) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_BONUS_ANALYTICS_ERROR })
                reject && reject(e)
            })
    },
    getCashierTransactions: (branchId, casherPhone, waiterId, dates, page, limit, sortBy, sortDir, resolve, reject) => async dispatch => {
        dispatch({ type: cashierBonusTypes.GET_CASHIER_TRANSACTIONS_PENDING })
        await cashierBonusApi.getCashierTransactions(branchId, casherPhone, waiterId, dates, page, limit, sortBy, sortDir)
            .then((data) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_TRANSACTIONS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_TRANSACTIONS_ERROR })
                reject && reject(e)
            })
    },
    getGroupCashierTransactions: (groupId, casherPhone, waiterId, dates, page, limit, sortBy, sortDir, resolve, reject) => async dispatch => {
        dispatch({ type: cashierBonusTypes.GET_CASHIER_TRANSACTIONS_PENDING })
        await cashierBonusApi.getGroupCashierTransactions(groupId, casherPhone, waiterId, dates, page, limit, sortBy, sortDir)
            .then((data) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_TRANSACTIONS_SUCCESS, payload: data })
                resolve && resolve()
            })
            .catch((e) => {
                dispatch({ type: cashierBonusTypes.GET_CASHIER_TRANSACTIONS_ERROR })
                reject && reject(e)
            })
    },
}

export default cashierBonusActions;
